import { Navigate, Outlet, useLocation } from "react-router-dom";

import { Skeleton } from "@/components/ui/skeleton";
import { useAuth } from "@/hooks/useAuth";
import { usePermissions } from "@/hooks/usePermissions";

export function FullPageLoader() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Skeleton className="h-8 w-64" />
    </div>
  );
}

/** Redirects anonymous visitors to the login page, preserving the target. */
export function RequireAuth() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <FullPageLoader />;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <Outlet />;
}

/** Denies access (403) when the principal lacks ANY of the required permissions. */
export function RequirePermission({ permissions }: { permissions: string[] }) {
  const { any } = usePermissions();
  if (!any(...permissions)) {
    return <Navigate to="/403" replace />;
  }
  return <Outlet />;
}

